var displayLeader = function() {
    var uuid = this.getAttribute("data-target");
    var leaderInfo = document.getElementById(uuid);
    //Get info from Card
    const name = leaderInfo.querySelector(".leader-name-hidden").textContent;
    const title = leaderInfo.querySelector(".leader-title-hidden").innerHTML;
    const bio = leaderInfo.querySelector(".leader-bio-hidden").innerHTML;
    const image = leaderInfo.querySelector(".leader-image-hidden").getAttribute("data-src");

    //push nav & footer back on open
    var bodyObj = document.body;
    bodyObj.classList.add("body--pushToBack");
    bodyObj.style.overflow = "hidden";

    const overlay = document.querySelectorAll(".modal-leader-overlay")[0];
    const closeModal = document.querySelectorAll(".leader-modal-close")[0];
    overlay.classList.add("active");
    // Load info into the PopUp
    overlay.querySelector(".leader-name").textContent = name;
    overlay.querySelector(".leader-title").innerHTML = title;
    overlay.querySelector(".leader-bio").innerHTML = bio;
    overlay.querySelector(".leader__image").setAttribute("data-src", image);
    overlay.querySelector(".leader__image").setAttribute("src", image);

    closeModal.focus();

    const closeModalFn = () => {
        overlay.classList.remove("active");
        bodyObj.classList.remove("body--pushToBack");
        bodyObj.style.overflow = "auto";
    };

    closeModal.addEventListener("click", closeModalFn);
    overlay.addEventListener("click", closeModalFn);
    overlay.querySelector(".leader-modal-wrapper").addEventListener("click", e => {
        e.stopPropagation();
    });
};

function triggerLeaderModal() {
    if (document.getElementsByClassName("leader-more")[0]) {
        var modalTriggers = document.getElementsByClassName("leader-more");
        Array.from(modalTriggers).forEach(function(e) {
            e.addEventListener("click", displayLeader);
        });
    }
}

function init() {
    triggerLeaderModal();
}

export default { init };
